import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { SectionHeading } from "../components/SectionHeading";
import { SERVICES } from "../lib/data";

const Icon = ({ name, className }) => {
  const C = Icons[name] || Icons.Circle;
  return <C className={className} />;
};

export default function Services() {
  return (
    <div data-testid="services-page" className="pt-28 pb-20 bg-cream-100 text-soil-700 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHeading
          as="h1"
          overline="Our Services"
          title="Complete Financial & Growth Solutions"
          subtitle="Explore our full range of loan, funding and multi-sector services — each engineered to get you approved and growing."
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <motion.div key={s.slug}
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.45, delay: (i % 3) * 0.08 }}>
              <Link to={`/services/${s.slug}`} data-testid={`services-list-${s.slug}`}
                className="group block h-full rounded-2xl overflow-hidden card-cream hover:border-forest-500/40 transition-all hover:-translate-y-1">
                <div className="relative h-40 overflow-hidden">
                  <img loading="lazy" decoding="async" src={s.hero} alt={s.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-forest-800/70 to-transparent" />
                  <div className="absolute bottom-3 left-4 w-11 h-11 rounded-xl gold-gradient flex items-center justify-center">
                    <Icon name={s.icon} className="w-5 h-5 text-cream-50" />
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="font-heading text-lg font-semibold text-forest-800 group-hover:text-terracotta-600 transition-colors">{s.title}</h3>
                  <p className="text-terracotta-600 text-xs font-medium mt-0.5">{s.tagline}</p>
                  <p className="text-soil-500 text-sm mt-2 line-clamp-2">{s.desc}</p>
                  <div className="flex items-center gap-1.5 text-terracotta-600 text-sm font-semibold mt-4">
                    View details <Icons.ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
